import { render, staticRenderFns } from "./categoriaPromociones.vue?vue&type=template&id=3b90cd36&scoped=true"
import script from "./categoriaPromociones.vue?vue&type=script&lang=js"
export * from "./categoriaPromociones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b90cd36",
  null
  
)

export default component.exports